<script>
import { inject, ref } from "vue";
import { Modal } from 'bootstrap';

import Note from '@/components/general/Note';
import Empty from '@/components/Modal/Empty';

import { store as storeFeedback } from "@/use/repositories/feedbacks/store";
import { update as updateTestWorkQueue } from '@/use/repositories/testWorkQueue/update';
import { changeState } from '@/use/repositories/users/changeState';
import { isCurrentDepartment } from "@/use/utilities/isCurrentDepartment";

import { useRouter } from "vue-router";
import { useStore } from "vuex";
import _head from "lodash/head";

export default {
  name: "Completed",
  emits: ['hidden'],
  props: {
    test_work_queue_phase_id: {
      type: [String, Number],
      required: false
    },
    test_work_queue_id: {
      type: [String, Number],
      required: false
    },
    is_last: {
      type: Boolean,
      default: false
    },
    children_test_work_queue_phase: {
      type: Array,
      default: () => []
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
  },
  components: {
    Note,
    Empty
  },
  setup(props) {
    const store = useStore();
    const { states, departments } = inject("constants");
    const nota = ref(store.state.clipboardDashboardTechnician);
    const router = useRouter();
    const modalRef = ref(null);

    const shipsWhenLast = () => props.is_last && isCurrentDepartment(departments.PROGETTAZIONE);

    const closeModal = () => {
      const modalEl = modalRef.value?.$el || modalRef.value;
      const modalInstance = Modal.getInstance(modalEl);
      if (modalInstance) modalInstance.hide();
    };
    // Change state and save note
    const save = async (testWorkQueuePhaseId, state) => {
      // Clear clipboard saved on vuex.
      await store.dispatch("setClipboardDashboardTechnician", "");

      await storeFeedback({
        test_work_queue_phase_id: parseInt(testWorkQueuePhaseId),
        state: state,
        is_iso: false,
        note: nota.value,
        action: "without_media",
      }).then(async () => {
        if (props.is_last) {
          updateTestWorkQueue({
            id: props.test_work_queue_id,
            state_slug: shipsWhenLast() ? states.SHIPPED : states.COMPLETED,
            action: "update_state"
          }).then((response) => {
            console.log(`UPDATE TWQ ID: ${response.testWorkQueue.id} STATE IN ${response.testWorkQueue.state.slug}`);
          });
        }
        closeModal();
        // Change user state.
        changeState('available').then(async () => {
          // Redirect
          await router.push({ name: "Checkin" });
        })
      });
    }

    const readNota = (value) => {
      store.dispatch("setClipboardDashboardTechnician", value);
      nota.value = value;
    }

    const getNextPhase = () => {
      if (!props.is_last) {
        return _head(props.children_test_work_queue_phase).internal_phase.name;
      }

      return shipsWhenLast() ? 'spedito' : 'check-out';
    }

    return {
      modalRef,
      save,
      readNota,
      nota,
      getNextPhase,
      closeModal,
    }
  }
}
</script>

<template>
  <Empty
    ref="modalRef"
    :modal_id="'modalTWQPCompleted'"
    :size="'lg'"
    :options="{ backdrop: 'static', keyboard: false }"
    @hidden="$emit('hidden', false)">
  <div class="p-4 text-center">
    <div class="p-1 border-0 text-center">
      <img class="me-1" src="@/assets/icons/warning.svg" width="30" alt="warning" />
      <h2 class="mb-4 fw-normal text-danger">{{ title ? $t(title) : $t('Work finished!') }}</h2>
      <p>{{ subtitle ?? $t('Congratulations, you have completed your work!') }}</p>
    </div>
    <div>
      <p>{{ $t('This work is about to be sent to') }} <strong>{{ getNextPhase() }}</strong></p>
      <Note :label="`${$t('Note for next work')}:`" :clipboard="nota" @message="readNota"> </Note>
    </div>
    <div class="p-1 border-0 justify-content-center">
      <button
        type="button"
        class="btn btn-violet text-uppercase m-2 mt-4"
        @click="save($props.test_work_queue_phase_id, 'completed')"
      >
        {{ $t('confirm') }}
      </button>
      <button
        type="button"
        class="btn btn-outline-violet text-uppercase m-2 mt-4"
        data-bs-dismiss="modal"
        @click="$emit('hidden', false)"
      >
        {{ $t('cancel') }}
      </button>

    </div>
  </div>
  </Empty>
</template>
